import { render, staticRenderFns } from "./ViewAvatarScreen.vue?vue&type=template&id=3e5f53db&scoped=true&"
import script from "./ViewAvatarScreen.vue?vue&type=script&lang=js&"
export * from "./ViewAvatarScreen.vue?vue&type=script&lang=js&"
import style0 from "./ViewAvatarScreen.vue?vue&type=style&index=0&id=3e5f53db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f53db",
  null
  
)

export default component.exports